export enum HolterPhase {
    clear = 'clear',
    clearRecording = 'clearRecording',
    configuration = 'configuration',
    detect = 'detect',
    read = 'read',
}
